<template>
    <div>
        <busca-inicial @aba="mudaAba" />

        <div class="boxbranco main-container" :class="mainSize" v-if="aba == 0 && listagemMapaLeitos != null">
            <sidebar-left />
            <mapa />
            <sidebar-right />
        </div>

        <div class="boxbranco main-container" :class="mainSize" v-if="aba == 1 && listagemMapaTipoLeito != null">
            <sidebar-left-tpleito />
            <mapa-tpleito />
            <sidebar-right-tpleito />
        </div>

    </div>
</template>

<script>
import BuscaInicial from './busca-inicial/BuscaInicial.vue'
import SidebarLeft from './unidade/sidebar-left/SidebarLeft.vue'
import Mapa from './unidade/mapa/Mapa.vue'
import SidebarRight from './unidade/sidebar-right/SidebarRight.vue'

import SidebarLeftTpleito from './tipoleito/sidebar-left-tpleito/SidebarLeftTpleito.vue'
import MapaTpleito from './tipoleito/mapa-tpleito/MapaTpleito.vue'
import SidebarRightTpleito from './tipoleito/sidebar-right-tpleito/SidebarRightTpleito.vue'

export default {
    components: {
        BuscaInicial,
        SidebarLeft,
        Mapa,
        SidebarRight,
        SidebarLeftTpleito,
        MapaTpleito,
        SidebarRightTpleito
    },
    mounted () {
        this.$store.dispatch('filtro/pegaListaUnidades')
        this.$store.dispatch('consultas/pegaListaProcedimentos')
        this.$store.dispatch('consultas/pegaListaCid')
        this.$store.dispatch('tipoleito/pegaTiposLeito')
        this.$store.dispatch('longapermanencia/pegaCategoriasLp')
        this.$store.dispatch('longapermanencia/pegaListaUnidadesProcedenciaLP')
    },
    data () {
        return {
            aba: '0'
        }
    },
    computed: {
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        listagemMapaTipoLeito () {
            return this.$store.getters['tipoleito/getMapaTipoLeito']
        },
    },
    methods: {
        mudaAba (value) {
            // ABA 0 = Busca por Unidade ---- ABA 1 = Busca por Leito Livre
            this.aba = value;
        },
    }
}
</script>

<style>
.main-container {
    max-width: 96%;
    margin: 0 auto;
    min-height: 500px;
    display: flex;
    flex-direction: column;
}

@media (min-width: 1154px) {
    .main-container {
        flex-direction: row;
    }
}
</style>
